module.exports = __webpack_public_path__ + "static/img/404.8bbbb379.png";